/**
 * Parallax Formatted Copy panel.
 * Background polygons scroll with a parallax effect.
 * Uses the Rellax JS library: https://github.com/dixonandmoe/rellax
 *
 * @author Brian McGill <github.com/bmcgill>
 */

import Rellax from 'rellax';
import debounce from 'debounce';

(function ($) {
  'use strict';

  let smallRellax, bigRellax;

  Drupal.behaviors.initializeParallaxFormattedCopy = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  function initialize() {
    let $parallax = $('.parallax-formatted-copy');

    if (!$parallax.length) return false;

    smallRellax = new Rellax('.polygon-small', {
      center: true,
    });

    bigRellax = new Rellax('.polygon-big', {
      center: true,
    });

    window.addEventListener('resize', debounce(refreshRellax));
  }

  /**
   * Refresh the Rellax objects on screen resize, otherwise they will not constrain to the parent block.
   */
  function refreshRellax() {
    smallRellax.refresh();
    bigRellax.refresh();
  }
})(jQuery);
